<template>
  <div class="jsStationAlerts">
    <div class="main-form ic-form header-form itinerary-form dark-form" :class="mainFormContainer">
      <form role="form"  name="searchTrain" method="post" :action="action" autocomplete="off"
        id="searchTrainForm">
        <slot name="extra"></slot>
        <div class="justify-content-between d-flex gy-4 flex-column" :class="localization === 'sidebar'?'':'flex-lg-row'">
          <div class="flex-grow-1 d-flex py-2 align-items-end" :class="localization === 'sidebar'?'p-0 py-lg-2':'p-lg-2'">

            <div class="typehead-container w-100">
              <slot name="destination-from">
                <label for="stname-0" class="form-label">Jadę z</label>
                <div role="combobox" aria-haspopup="listbox" aria-expanded="false" class="start no-border">
                  <div class="input-group">
                    <input type="search" id="stname-0" name="stname[0]" :value="stname0"
                      class="jsStationTypeaheadItem jsNearestStationItem form-control"
                      placeholder="np. Warszawa Centralna" autocomplete="off" role="searchbox" aria-multiline="false"
                      aria-autocomplete="list" />
                    <input type="hidden" name="stid[0]" id="stid-0" :value="stid0" class="jsTypeaheadItem-Value" />
                  </div>
                </div>
              </slot>
            </div>
          </div>
          <div class="d-none " :class="localization === 'sidebar'?'':'d-lg-block'" style="width:32px">
            <a @click.prevent=reverse class="switch d-flex h-100 align-items-center focus" tabindex="0">

              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M25.2379 7.93561L21.4398 4.06365C20.929 3.54295 20.0929 3.5349 19.5722 4.04567L19.5273 4.09109C19.0186 4.60963 19.0186 5.43993 19.5273 5.95847L21.1772 7.64095L4.04927 7.63962C3.31289 7.63962 2.71594 8.23658 2.71594 8.97296L2.71594 9.02478C2.71594 9.76116 3.31289 10.3581 4.04927 10.3581L21.0759 10.3583L19.5273 11.9356C19.0186 12.4542 19.0186 13.2845 19.5273 13.803L19.5542 13.8304C20.065 14.3511 20.9011 14.3592 21.4218 13.8484L21.4398 13.8304L25.2379 9.95847C25.4727 9.71914 25.5991 9.41341 25.6172 9.10256L25.6172 8.79152C25.5991 8.48068 25.4727 8.17494 25.2379 7.93561Z"
                  fill="#FA6A2E" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.76205 24.0643L6.5602 27.9362C7.07098 28.4569 7.90715 28.465 8.42785 27.9542L8.47274 27.9088C8.9814 27.3903 8.9814 26.56 8.47274 26.0414L6.82281 24.3589L22.9507 24.3603C23.6871 24.3603 24.2841 23.7633 24.2841 23.0269L24.2841 22.9751C24.2841 22.2387 23.6871 21.6418 22.9507 21.6418L6.92415 21.6416L8.47274 20.0643C8.9814 19.5457 8.9814 18.7154 8.47274 18.1969L8.44582 18.1695C7.93505 17.6488 7.09887 17.6407 6.57818 18.1515L6.5602 18.1695L2.76205 22.0414C2.52728 22.2808 2.40087 22.5865 2.38281 22.8973L2.38281 23.2084C2.40087 23.5192 2.52728 23.825 2.76205 24.0643Z"
                  fill="#FA6A2E" />
              </svg>

              <span class="sr-only">Zamień stację odjazdu ze stacją przyjazdu.</span>
            </a>
          </div>
          <div class="flex-grow-1 d-flex py-2 align-items-end" :class="localization === 'sidebar'?'p-0 py-lg-2':'p-lg-2'">
            <div class="typehead-container w-100">
              <slot name="destination-to">
                <label for="stname-1" class="form-label">Jadę do</label>
                <div role="combobox" aria-haspopup="listbox" aria-expanded="false" class="end no-border">
                  <div class="input-group">
                    <input type="search" id="stname-1" name="stname[1]" :value="stname1"
                      class="jsStationTypeaheadItem jsNearestStationItem form-control" placeholder="np. Szczecin Gł."
                      autocomplete="off" role="searchbox" aria-multiline="false" aria-autocomplete="list" />
                    <input type="hidden" name="stid[1]" id="stid-1" :value="stid1" class="jsTypeaheadItem-Value" />
                  </div>
                </div>
              </slot>
            </div>
          </div>
          <div class=" d-flex py-2 align-items-end" :class="localization === 'sidebar'?'p-0 py-lg-2 col-lg-12':'col-lg-4 p-lg-2'">
            <slot name="date-time-pickers">
              <date-time></date-time>
            </slot>
          </div>
          <div class="d-flex py-2 align-items-end" :class="localization === 'sidebar'?'p-0 py-lg-2':'p-lg-2'" style="min-width: 130px;">
            <input type="hidden" name="hafasPage" value="{$hafas_page}" class="jsVariable-HafasPage" />
            <input type="hidden" name="hafasSort" value="" class="jsVariable-HafasSort" />
            <input type="hidden" name="search" value="1" class="jsVariable-HafasSort" />
            <div id='recaptcha' class="g-recaptcha" data-tabindex="99"
              data-sitekey="6LfNgbIZAAAAAJRnN7xCoQZH-gq-fiMYFAoNxOcR" data-callback='onSubmitSearchForm'
              data-action='submit' data-size="invisible"></div>
            <button type="submit" name="search" value="1" class="btn btn-warning w-100"
              onClick="return grecaptcha.execute();">{{ $t('icsearch_wyszukaj') }}</button>
          </div>
        </div>
        <div>
          <slot name="dev"></slot>
        </div>
      </form>
    </div>
    <div class="alerts mt-3">
      <slot name="alerts-slot">
        <div class="alert alert-warning font-size-sm d-flex" role="alert">
          <div class="me-4 text-danger">
            <i class="bi bi-exclamation-circle"></i>
          </div>
          <div>
            W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących.<br>
          <a href="#">Więcej informacji na temat obowiązujących zasad w podróży</a>
            <br><br>
            W pociągach PKP Intercity jednocześnie zajętych może być co najwyżej 50 proc. miejsc siedzących.<br>
          <a href="#">Więcej informacji na temat obowiązujących zasad w podróży</a>
          </div>
        </div>
      </slot>
      <slot name="info"></slot>
    </div>
  </div>
</template>
<script>
//import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import DateTime from './inputs/date-time';
import 'vue2-datepicker/index.css';
import { debounce } from 'lodash';
import Vue from "vue";

export default {
  name: 'itinerary-adv-form',
  props: {
    action: '/pl/site/dla-pasazera/informacje/wyszukiwarka-polaczen.html',
    forceAdvView: false,
    wymus: String,
    localization: {
      type: String,
      default: 'top'
    },
    stid0: String,
    stid1: String,
    stname0: String,
    stname1: String,
  },
  components: {
    //VueTypeaheadBootstrap,
    DateTime
  },
  data() {
    return {
      query1: '',
      users: [],

      query2: '',
      query3: '',
      time: null,
      isQuery2AdditionalInfoAvailable: false,
      query2AdditionalInfo: ' ',
      query2Class: 'plus',
      isAdvancedViewActive: false,
      isViaVisible: false,
      isMobile: false,
      isSimpleViewActive: false,
      focusableElementsString: "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]",
    }
  },
  computed: {
    searchBtn: function () {
      let cl = 'col-12 justify-content-center';
      if (this.isAdvancedViewActive)
        cl = 'col-12 col-md-4 offset-md-4 justify-content-md-end  justify-content-center';
      return cl;
    },
    mainFormContainer: function () {
      let cl;

      let fixedMobile = 'position-fixed h-100 top-0 start-0  overflow-auto zindex-fixed';

      if (window.kategoria_podstrona)
        var absoluteDesktop = 'top-0 start-0 ';
      else if (window.podstrona)
        var absoluteDesktop = 'position-fixed top-50 start-50 translate-middle ';
      else
        var absoluteDesktop = 'position-absolute top-0 start-0 ';

      if (this.localization === 'top') {
        cl = 'localization-top';

        if (this.isAdvancedViewActive) {
          if (this.forceAdvView)
            cl = '';
          else {
            if (this.isMobile) {
              cl = fixedMobile;
            }
            else {
              cl = absoluteDesktop;
            }
          }
        }
      }
      if (this.localization === 'sidebar') {
        if (this.isMobile)
          if (this.isSimpleViewActive)
            cl = fixedMobile;
          else
            cl = 'd-none';

        if (this.isAdvancedViewActive) {
          if (this.isMobile)
            cl = fixedMobile;
          else
            cl = absoluteDesktop;
        }
      }

      return cl;
    },
    destinations: function () {
      let cl = 'col-12 ';
      if (this.isAdvancedViewActive)
        cl = 'col-12 col-lg-4';
      return cl;
    },
    timeDetails: function () {
      let cl = 'col-12';
      if (this.isAdvancedViewActive)
        cl = 'col-12 col-lg-4';
      return cl;
    }
  },
  methods: {
    reverse() {
      var n0 = $("#stname-0").val();
      var n1 = $("#stname-1").val();
      var i0 = $("#stid-0").val();
      var i1 = $("#stid-1").val();
      $("#stname-0").val(n1);
      $("#stname-1").val(n0);
      $("#stid-0").val(i1);
      $("#stid-1").val(i0);

      //console.log("reverse");

    },
    showSimpleView() {
      this.isSimpleViewActive = true;
    },
    showSimpleViewDesktop() {
      $("#floatingSearch").removeClass('d-lg-none').addClass("position-fixed top-50 start-50 translate-middle");
      $("#floatingSearchB").removeClass('d-none');

      this.focusInput();
      this.isSimpleViewActive = true;
    },
    hideSimpleViewDesktop() {
      $("#floatingSearch").addClass('d-lg-none').removeClass("position-fixed top-50 start-50 translate-middle");
      $("#floatingSearchB").addClass('d-none');
      this.isSimpleViewActive = false;
      if (this.isAdvancedViewActive)
        this.hideAdvView();
      this.focusInput();
    },
    hideSimpleView() {
      this.isSimpleViewActive = false;
      if (this.isAdvancedViewActive)
        this.hideAdvView();
      this.focusInput();
    },
    showAdvView() {
      this.isAdvancedViewActive = true;
      this.focusInput();
    },
    hideAdvView() {
      this.isAdvancedViewActive = false;
      if (!window.kategoria_podstrona)
        $("#floatingSearchB").addClass('d-none');

      var modal = $("#searchTrainForm").parent();
      modal.prop({ "tabindex": null, "role": false }).attr({ "aria-modal": "false" });
      modal.off('keydown');

    },
    toggleAdvView($event) {

      if (this.isAdvancedViewActive) {
        $("#floatingSearch").removeClass("advanced");
        if (!window.kategoria_podstrona)
          $("#floatingSearchB").addClass('d-none');

        var modal = $("#searchTrainForm").parent();
        modal.prop({ "tabindex": null, "role": false }).attr({ "aria-modal": "false" });
        modal.off('keydown');

        this.isAdvancedViewActive = false;
        this.focusInput();

      }
      else {
        $("#floatingSearch").addClass("advanced");
        $("#floatingSearchB").removeClass('d-none');
        var modal = $("#searchTrainForm").parent();

        modal.prop({ "tabindex": -1, "role": "dialog" }).attr({ "aria-modal": "true", "aria-labelledby": "modal-label" });


        modal.on('keydown', function ($event) {
          trapTab(modal, $event);
        });


        this.isAdvancedViewActive = true;
        this.focusInput();
      }
    },
    focusInput() {
      $("#stname-0").focus();
    },
    showVia() {
      this.isViaVisible = true;
      setTimeout(() => $("#vianame-1, #vianame-0").focus(), 100);
    },
    searchUsers: debounce(function () {
      if (this.query1.length > 0) {
        fetch(`https://api.github.com/search/users?q=${this.query1}`)
          .then(response => {
            return response.json();
          })
          .then(data => {
            this.users = data.items;
          })
      }
    }, 150),
    showTicketSearch: function (evt) {

      if (window.kategoria_podstrona && !this.isMobile)
        this.showSimpleViewDesktop();
      else
        this.showSimpleView();


    },
    handleResize() {
      this.$nextTick(() => {
        this.isMobile = window.innerWidth < 992;
      })
    },
  },
  watch: {
    forceAdvView: {
      handler: function () {
        if (this.forceAdvView)
          this.showAdvView();
      },
      immediate: true
    }
  },
  created: function () {
    this.$bus.$on('show-ticket-search', this.showTicketSearch);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    if (this.wymus) this.forceAdvView = true;

    var that = this;
    setTimeout(function () {
      if ($("#vianame-1, #vianame-0").val()) {
        that.isViaVisible = true;
      }

      var e = $('#ic-search-results');
      //console.log(e,'test');
      if (e.length > 0) {

        $('body,html').animate({
          'scrollTop': e.offset().top - 50
        }, 200);
      }

    }, 500)

  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}


</script>
<style>
.cursor-pointer {
  cursor: pointer;
}
</style>